var weakMemoize=function weakMemoize(func){// $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
var cache=new WeakMap();return function(arg){if(cache.has(arg)){// $FlowFixMe
return cache.get(arg);}var ret=func(arg);cache.set(arg,ret);return ret;};};export default weakMemoize;